<template>
  <!--Zero width space to prevent layout shift, before title is loaded-->
  <CommonSectionLabel :title="label?.name ?? '&ZeroWidthSpace;'" />
</template>
<script setup lang="ts">
const route = useRoute()
const subject =
  route.params.subject?.toString() ?? route.params.theme?.toString()
const nuxtApp = useNuxtApp()
const { data: label } = await useAsyncData(async () => {
  return await nuxtApp.$api.houses.get(subject)
})
</script>
